export class CaseDetailsPanelState {
    IsSidebarExpanded: boolean;
    IsQualityCheckExpanded: boolean;
    IsCaseOverviewExpanded: boolean;
    IsCaseSummaryExpanded: boolean;
    IsApprovedAuditScopeExpanded: boolean;
    IsContactStatusExpanded: boolean;
    IsInspectorReportExpanded: boolean;
    IsCaseHeaderSlaExpanded: boolean;
    IsIpexLumaExpanded: boolean;
    IsServiceListExpanded: boolean;
    IsCaseReferenceExpanded: boolean;
    IsCaseHistoryExpanded: boolean;
    IsPolicyHolderExpanded: boolean;
    IsCommentsExpanded: boolean;
}

// Must match each section component's initial value, so users with no saved state see the usual layout.
export const DEFAULT_CASE_DETAILS_PANEL_STATE: CaseDetailsPanelState = {
    IsSidebarExpanded: true,
    IsQualityCheckExpanded: false,
    IsCaseOverviewExpanded: true,
    IsCaseSummaryExpanded: true,
    IsApprovedAuditScopeExpanded: true,
    IsContactStatusExpanded: true,
    IsInspectorReportExpanded: false,
    IsCaseHeaderSlaExpanded: true,
    IsIpexLumaExpanded: true,
    IsServiceListExpanded: true,
    IsCaseReferenceExpanded: true,
    IsCaseHistoryExpanded: true,
    IsPolicyHolderExpanded: true,
    IsCommentsExpanded: true
};
